export const tr = {
    'gender-and-age': 'cinsiyet: {gender}, yaş: {age}',
    'on-condition': '"{condition}" koşuluna göre'
};
